/**
 * "This didn't load", the reason in plain words, and Try again. With `stale`, the last answer stays on screen below
 * and the note says how old it is. Ink, not Signal: a failed request is not an outage.
 */
import type { ReactNode } from 'react'
import { Button } from '../primitives/Button'
import s from './States.module.css'

export function ErrorNote({ title = "This didn't load.", reason, stale, onRetry }: { title?: string; reason: ReactNode; /** "Showing the answer from 2 minutes ago." */ stale?: string; onRetry?: () => void }) {
  return (
    <div className={s.err} role="alert">
      <div>
        <p className={s.errTitle}>{title}</p>
        <p className={s.errReason}>{reason}</p>
        {stale && <p className={s.stale}>{stale}</p>}
      </div>
      {onRetry && (
        <Button size="sm" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  )
}
